import { useEffect, useRef } from "react";

/**
 * V1.87 · Mantiene una vista al día sin tener que recargar la página:
 * recarga cuando cualquier parte de la app escribe datos (evento
 * `app-data-changed` que emite el interceptor de api.js) y al volver a la
 * pestaña del navegador. Se agrupa con un pequeño retardo para que una
 * creación masiva no dispare decenas de recargas.
 */
export function useDataRefresh(load, { delay = 800 } = {}) {
  const timer = useRef(null);

  useEffect(() => {
    if (typeof load !== "function") return undefined;
    const schedule = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => load(), delay);
    };
    const onFocus = () => load();
    window.addEventListener("app-data-changed", schedule);
    window.addEventListener("focus", onFocus);
    return () => {
      if (timer.current) clearTimeout(timer.current);
      window.removeEventListener("app-data-changed", schedule);
      window.removeEventListener("focus", onFocus);
    };
  }, [load, delay]);
}

export default useDataRefresh;
